import type { FirmLogoFillItem } from "../../../api/firmLogoFill.service.js";
import { WEBSITE_OPTIONS } from "../../../constants/features.js";

export function websiteLabel(website: FirmLogoFillItem["website"]): string {
  if (website === null) {
    return "Unknown website";
  }

  return WEBSITE_OPTIONS.find(option => option.value === website)?.label ?? website;
}

export function locationLabel(item: FirmLogoFillItem): string {
  if (item.countryId === null) {
    return "Firm-wide";
  }

  return item.countryName ?? `Unknown location (${item.countryId})`;
}
